import { Config } from '@/config'

export function videoUrl(video: string) {
  let url: string

  if (video !== undefined) {
    url = video

    if (/^https?/.test(url) === false) {
      if (/^[0-9a-z]*\.(mp4)/.test(url)) {
        url = `${Config.VideoBaseUrl}/${video}`
      }
    }
  } else {
    url = ''
  }

  return url
}
